import { render, staticRenderFns } from "./numberInput.vue?vue&type=template&id=54489468"
import script from "./numberInput.vue?vue&type=script&lang=js"
export * from "./numberInput.vue?vue&type=script&lang=js"
import style0 from "./numberInput.vue?vue&type=style&index=0&id=54489468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports